import React, { useState, useRef, useEffect } from 'react';

function formatDate(iso) {
  const d = new Date(iso);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export default function CardItem({ card, onAction, selectable, selected, onSelect }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const menuRef = useRef();

  useEffect(() => {
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const isLong = card.body.length > 200;

  const actions = {
    active: [
      { label: 'Edit', key: 'edit' },
      { label: 'Archive', key: 'archive' },
      { label: 'Delete', key: 'delete', danger: true },
    ],
    archived: [
      { label: 'Edit', key: 'edit' },
      { label: 'Restore to Box', key: 'restore' },
      { label: 'Delete', key: 'delete', danger: true },
    ],
    deleted: [
      { label: 'Restore to Box', key: 'restore' },
    ],
  };

  const menuItems = actions[card.status] || [];

  return (
    <div className="card" style={{ paddingLeft: selectable ? '2.5rem' : undefined }}>
      {selectable && (
        <input
          type="checkbox"
          className="card-select-cb"
          checked={selected}
          onChange={e => onSelect(card.id, e.target.checked)}
        />
      )}

      <div
        className={`card-body ${isLong && !expanded ? 'truncated' : ''}`}
        onClick={() => isLong && setExpanded(!expanded)}
        style={{ cursor: isLong ? 'pointer' : 'default', paddingRight: '2rem' }}
      >
        {card.body}
      </div>

      {isLong && (
        <button
          onClick={() => setExpanded(!expanded)}
          style={{ background: 'none', border: 'none', color: 'var(--accent)', cursor: 'pointer', fontSize: '0.82rem', fontFamily: 'sans-serif', padding: '0.25rem 0', marginTop: '0.25rem' }}
        >
          {expanded ? 'Show less' : 'Show more'}
        </button>
      )}

      <div className="card-meta">
        <span className="card-date">{formatDate(card.created_at)}</span>
        {card.tags && card.tags.map(t => (
          <span key={t.id} className="tag">{t.name}</span>
        ))}
      </div>

      {menuItems.length > 0 && (
        <div className="card-actions" ref={menuRef}>
          <button className="card-menu-btn" onClick={() => setMenuOpen(!menuOpen)}>•••</button>
          {menuOpen && (
            <div className="context-menu">
              {menuItems.map(item => (
                <button
                  key={item.key}
                  className={item.danger ? 'danger' : ''}
                  onClick={() => { setMenuOpen(false); onAction(card, item.key); }}
                >
                  {item.label}
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
